:host {
    background-color: transparent;
    display: block;
    font-family: 'PT Sans';
    
    muse-status-message {
        display: block;
        margin: 16px 0;
    }

    c-form {
        background-color: transparent;
    }

    c-form span.label-like {
        position: relative;
        font-family: "PT Sans Caption", Helvetica, Arial, sans-serif;
        font-weight: bold;
        color: rgba(24, 52, 71, 0.72);
        padding: 4px 0;
        display: block;
        font-size: 1.4rem;
        line-height: 1.35714;
        outline: none;
        overflow: visible;
    }

    .confirmation-wrapper {
        padding: 0 16px;
        position: relative;
    }

    @media only screen and (min-width: 390px) {
        .confirmation-wrapper {
            padding: 0 32px;
        }
    }
    @media only screen and (min-width: 768px) {
        .confirmation-wrapper {
            padding: 0;
        }
    }

    c-markdown-renderer, a-radiogroup, a-checkbox {
        margin-bottom: 20px;
    }

    .error-body {
        color: #a7003b;
    }

    muse-checkbox {
        position: relative;
        cursor: pointer;
    }
}
